module.exports = __webpack_public_path__ + "static/img/error.505cfc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.png
// module id = 76Xz
// module chunks = 1